import React, { } from 'react';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';

import './index.scss';

const FilterVsButton: React.FC<{ nameEn?: string; nameCn?: string; }> = ({
  nameEn = 'VS',
  nameCn = 'VS',
}) => {
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  return (<div className='dbl-filter-vs-button'>
    {getLanguage(isEn, nameEn, nameCn)}
  </div>);
};

export default FilterVsButton;